// extracted by mini-css-extract-plugin
module.exports = {"dialog--footer":"dialog--footer__2MPR-","dialog--footer__padding-off":"dialog--footer__padding-off__2VuIx"};